import { call, put, takeEvery } from 'redux-saga/effects';
import { createNewsletterAPI, deleteNewsletterAPI, getNewsletterAPI, updateNewsletterAPI } from "../Services"
import { ADD_NEWSLETTER, ADD_NEWSLETTER_RED, DELETE_NEWSLETTER, DELETE_NEWSLETTER_RED, GET_NEWSLETTER, GET_NEWSLETTER_RED, UPDATE_NEWSLETTER, UPDATE_NEWSLETTER_RED } from "../Constant"

// / Create Notifaction Saga
function* createNewsletterSaga(action) {
    try {
        const response = yield call(createNewsletterAPI, action.payload);
        if (response && response.data) {
            yield put({ type: ADD_NEWSLETTER_RED, data: response.data });
        } else {
            console.error("Create Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in createNewsletterSaga:", error);
    }
}

// Get Notifaction Saga
function* getNewsletterSaga() {
    try {
        const response = yield call(getNewsletterAPI);
        if (response && response.data) {
            yield put({ type: GET_NEWSLETTER_RED, data: response.data });
        } else {
            console.error("Get Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in getNewsletterSaga:", error);
    }
}

// Delete Notifaction Saga
function* deleteNewsletterSaga(action) {
    try {
        const response = yield call(deleteNewsletterAPI, action.payload);
        if (response) {
            yield put({ type: DELETE_NEWSLETTER_RED, data: action.payload });
        } else {
            console.error("Delete Category API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in deleteNewsletterSaga:", error);
    }
}

// Notifaction Saga (Watcher)
export function* newsletterSaga() {
    yield takeEvery(ADD_NEWSLETTER, createNewsletterSaga);
    yield takeEvery(GET_NEWSLETTER, getNewsletterSaga);
    yield takeEvery(DELETE_NEWSLETTER, deleteNewsletterSaga);
}
